import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * All Trips list configuration (post-Phase-A rename: was "All Routes" when
 * `route` table held instances; now the instances live in `trip` and this
 * list backs the Trips landing page).
 */
export const allTripsList: ListBuilderList = {
	id: 'default-trips',
	name: 'All Trips',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-desc',
	sortOrder: 2,
};
